import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import {
  Form,
  InputPassword,
  useFormConfig,
  FormBloc,
  FormField,
  FormRow,
  PasswordCriterias,
} from "@endya-conformite/ui-kit";
import { passwordWithConfirmationSchema } from "@src/user/Signup/password.definition";

const schema = zod.object({
  previousPassword: zod.string(),
  password: passwordWithConfirmationSchema,
});
export type UpdatePasswordFormValues = zod.infer<typeof schema>;

type UpdatePasswordFormProps = {
  onSubmit: (values: UpdatePasswordFormValues) => Promise<void>;
  formId: string;
  defaultValues?: UpdatePasswordFormValues;
};

export function UpdatePasswordForm({
  onSubmit,
  formId,
  defaultValues,
}: UpdatePasswordFormProps) {
  const formConfig = useFormConfig<typeof schema, UpdatePasswordFormValues>({
    schema,
    defaultValues,
  });

  const passwordValue = formConfig.watch("password.password");

  return (
    <Form formConfig={formConfig} onSubmit={onSubmit} id={formId}>
      <FormRow>
        <FormField>
          <InputPassword<UpdatePasswordFormValues>
            name="previousPassword"
            label="Ancien mot de passe"
            required
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField>
          <InputPassword<UpdatePasswordFormValues>
            name="password.password"
            label="Nouveau mot de passe"
            required
          />
        </FormField>
      </FormRow>

      <FormBloc>
        <PasswordCriterias password={passwordValue} />
      </FormBloc>

      <FormRow>
        <FormField>
          <InputPassword<UpdatePasswordFormValues>
            name="password.confirm"
            label="Confirmer le nouveau mot de passe"
            required
          />
        </FormField>
      </FormRow>
    </Form>
  );
}
